// components/portal/declaredSeries.ts
//
// The declared curve's grouping rule, in its own plain module so the chart and the tests share
// one copy. A dashed line may only join years that share SOURCE and CURRENCY: two press claims
// with different perimeters must render as rows without a line, while a multi-year series from
// one register draws. A single year draws as a point: every figure we hold appears on the chart.
export const pickDeclaredSeries = (
  rows: Array<{ year: number; revenue: number; currency: string; source: string | null }> | null | undefined,
): { points: Array<{ x: string; y: number }>; currency: string; source: string } | null => {
  // ONE CURVE PER CURRENCY, whatever the pages: a series cited from an annual report, a trade
  // article and a press release is still one company's revenue over three years, and grouping by
  // page left Emma's 2022-24 group figures as three loose lines and no curve (owner, 2026-09-27).
  // Each point keeps its own page in the list under the chart.
  const groups = new Map<string, Array<{ year: number; revenue: number; source: string }>>();
  for (const r of rows ?? []) {
    if (!(typeof r.revenue === 'number' && r.revenue > 0 && typeof r.year === 'number' && r.source)) continue;
    const key = (r.currency ?? 'EUR').toUpperCase();
    const years = groups.get(key) ?? [];
    if (years.some((row) => row.year === r.year)) continue;
    groups.set(key, [...years, { year: r.year, revenue: r.revenue, source: r.source }]);
  }
  const best = [...groups.entries()].sort((a, b) => b[1].length - a[1].length)[0];
  if (!best) return null;
  const [currency, rows2] = best;
  const sources = [...new Set(rows2.map((r) => r.source))];
  return {
    points: rows2.sort((a, b) => a.year - b.year).map((r) => ({ x: String(r.year), y: r.revenue })),
    currency,
    source: sources.length === 1 ? sources[0]! : `${sources.length} sources`,
  };
};
